import React from 'react';
import ClientRegisterComponent from './client-registration.component';

function ClientRegister() {
    return <ClientRegisterComponent />;
}

export default ClientRegister;
